import React, { useEffect, useRef, useState } from 'react';
import { Popover } from 'antd';
import DashboardSummery from './components/dashboardSummery.tsx';
import DistributionGraph from './components/distributionGraph.tsx';
import { useNavigate } from 'react-router-dom';
import * as Img from '../../../assets/index.js';
import HorizontalGraph from './components/horizontalGraph.tsx';
import EnergyConsumtionGraph from './components/energyConsumtionGraph.tsx';
import EnergyLineGraph from './components/energyLineGraph.tsx';;


const DashboardPage = () => {
    const svgRef = useRef(null);
    const navigate = useNavigate();
    const [points, setPoints] = useState([
        { id: 1, x: '18%', y: '48%', name: 'ES 001' },
        { id: 2, x: '86%', y: '34%', name: 'ES 002' },
        { id: 3, x: '78%', y: '48%', name: 'ES 003' },
    ]);
    const [svgElement, setSvgElement] = useState(null);
    const handlePointClick = (pointId) => {
        // /admin/main
        navigate('/admin/building')
    };
    const convertPercentageToPixels = (percentage, total) => {
        return (parseFloat(percentage) / 100) * total;
    };

    // Function to generate the path for a curve between two points
    const generateCurvedPath = (p1, p2) => {
        let svgElement = document.getElementById('dashboard-img-path-svg');
        console.log(svgElement);
        if (!svgElement) {
            return;
        }
        let svgHeight = svgElement.clientHeight;
        let svgWidth = svgElement.clientWidth;
        const x1 = convertPercentageToPixels(p1.x, svgWidth);
        const y1 = convertPercentageToPixels(p1.y, svgHeight);
        const x2 = convertPercentageToPixels(p2.x, svgWidth - 20);
        const y2 = convertPercentageToPixels(p2.y, svgHeight);

        const controlX1 = (x1 + x2) / 4.6;
        const controlY1 = (y1 + y2) / 9;
        const controlX2 = (x1 + x2) / 2.75;
        const controlY2 = (y2 + y1) / 10;

        return `M${x1},${y1} C${controlX1},${controlY1} ${controlX2},${controlY2} ${x2},${y2}`;
    };
    const resetSvgElement = () => {
        const svgEl = (<svg className="svg-overlay">
            <defs>
                <filter id="pulse-glow" x="-100%" y="-100%" width="300%" height="300%">
                    <feGaussianBlur stdDeviation="4" result="blur" />
                    <feOffset dx="0" dy="0" result="offsetblur" />
                    {/* <feFlood flood-color="blue" result="color" /> */}
                    <feComposite in2="offsetblur" operator="in" />
                    <feMerge>
                        <feMergeNode />
                        <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
            </defs>


            {[1, 2].map((pointIndex, index) => {
                // Draw lines between consecutive points
                let point = points[0];
                if (index < points.length - 1) {
                    const nextPoint = points[pointIndex];
                    const svgElement = svgRef.current;

                    const path = generateCurvedPath(point, nextPoint);
                    return (
                        <path
                            className='glow-path'
                            d={path}
                            stroke="red"
                            fill="transparent"
                            strokeWidth="2"
                            filter="url(#pulse-glow)"
                        />
                    );
                }
                return null;
            })}
        </svg>);
        setSvgElement(svgEl);
    }
    useEffect(() => {
        window.addEventListener('resize', () => {
            resetSvgElement();
        });
        return () => {
            window.removeEventListener('resize', () => {
                resetSvgElement();
            });
        };
    }, []);
    useEffect(() => {
        setTimeout(() => {
            resetSvgElement();
        }, 1000)
    }, [])

    return (
        <>
            <div className='row m-0'>
                <div className='col-md-3 col-sm-12 p-0'>
                    <DashboardSummery />
                    <div>
                        <HorizontalGraph />
                    </div>
                </div>
                <div className='col-md-6 col-sm-12 p-0'>
                    <div className="image-container">
                        <img
                            src={Img.ParkDemoImgJpg}
                            alt="Park"
                            id='dashboard-img-path-svg'
                            className="responsive-image"
                        />
                        <div className='c-img-title'>
                            {/* <div> */}
                            <h5 className='img-title'>ES Industrial Park Demo</h5>
                            {/* </div> */}
                        </div>
                        {svgElement}
                        {points.map((point) => (
                            <Popover content={point.name} trigger="hover" color='black' placement="right">
                                <div
                                    key={point.id}
                                    className="clickable-point"
                                    style={{ left: point.x, top: point.y }}
                                    onClick={() => handlePointClick(point.id)}
                                >
                                    <div className='c-point'>
                                        <div className='point-dot'></div>
                                        <div className='point-name'>{point.name}</div>
                                    </div>
                                </div>
                            </Popover>
                        ))}
                    </div>
                    <EnergyConsumtionGraph />

                </div>
                <div className='col-md-3 col-sm-12'>
                    <div>
                        <DistributionGraph />
                    </div>
                    <div>
                        <EnergyLineGraph />
                    </div>
                </div>
            </div>
        </>
    )
}
export default DashboardPage;